<template>
    <div class="profile-help">
        Help
    </div>
</template>

<script>
    export default {
        name: "ProfileHelp"
    }
</script>

<style scoped>

</style>
